import React from 'react';
import { UATConstants } from 'src/Common/Models/UATConstants';

const AccessRestrictionPage: React.FC = () => (
  <div className='unauthorized-div'>
    <img
      className='unauthroized-img'
      alt={UATConstants.PlaceholdersAndTitles.Unauthorized}
      src='/images/unauthorized.png'
      height='40%'
      width='100%'
    />
    <h1>{UATConstants.PlaceholdersAndTitles.NotAuthorizedViewPage}</h1>
    <p>
      {' '}
      {UATConstants.PlaceholdersAndTitles.PleaseClick}{' '}
      <a
        target='_blank'
        href='https://aka.ms/uataccess'
        rel='noreferrer'
        style={{ textDecoration: 'none', fontWeight: 'bold' }}>
        {UATConstants.PlaceholdersAndTitles.Here}
      </a>{' '}
      {UATConstants.PlaceholdersAndTitles.RequestAccessText}
    </p>
  </div>
);

export default AccessRestrictionPage;
// Generated by GitHub Copilot | Updated on: 2026-10-12 | 29 lines created | Shared existing access restriction page
